import { memo, type PointerEvent } from 'react';

import { XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { useBreakpointsContext } from '@air/provider-media-query';

import { SearchFieldClearButton, type SearchFieldClearButtonProps } from '~/components/Search/SearchFieldClearButton';

export type SearchCommandClearButtonProps = {
  label?: string;
  onClick: SearchFieldClearButtonProps['onClick'];
};

const stopPointerDownPropagation = (event: PointerEvent<HTMLButtonElement>) => {
  event.stopPropagation();
};

export const SearchCommandClearButton = memo(({ label = 'Clear', onClick }: SearchCommandClearButtonProps) => {
  const { isAboveMediumScreen } = useBreakpointsContext();

  if (isAboveMediumScreen) {
    return <SearchFieldClearButton data-testid="SEARCH_COMMAND_CLEAR_BUTTON" label={label} onClick={onClick} />;
  }

  return (
    <IconButton
      adsIcon
      appearance="ghost"
      className="absolute top-2 right-2"
      color="gray"
      data-testid="SEARCH_COMMAND_CLEAR_BUTTON"
      icon={XIcon}
      label={label}
      size="small"
      onClick={onClick}
      onPointerDown={stopPointerDownPropagation}
    />
  );
});

SearchCommandClearButton.displayName = 'SearchCommandClearButton';
